import * as types from '../types';
import { IFlatContractBillingApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class FlatContractBillingHttpApi extends HttpApi implements IFlatContractBillingApi {
  async previewFlatContractBilling(): Promise<types.FlatContractPreview> {
    const response = await this.http.get<types.APIResponse<types.FlatContractPreview>>('/flat-contract-billing/preview');
    return response.data.data;
  }

  async billFlatContracts(data: types.BillFlatContractsRequest): Promise<types.BillFlatContractsResult> {
    const response = await this.http.post<types.APIResponse<types.BillFlatContractsResult>>('/flat-contract-billing/bill', data);
    return response.data.data;
  }
}
